<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{title}}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="3">
                <div class="form-group">
                  <label for="user">User</label>
                  <model-select
                    class="form-control"
                    id="user"
                    :options="userList"
                    v-model="$v.notificationForm.user_code.$model"
                    :isError="$v.notificationForm.user_code.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.notificationForm.user_code.$invalid"
                    class="invalid-feedback-custom"
                  >User should be filled.</div>
                </div>
              </CCol>              
              <CCol sm="3">
                <div class="form-group">
                  <label for="icon">Type</label>
                  <model-select
                    class="form-control"
                    id="type"
                    :options="typeList"
                    v-model="$v.notificationForm.notification_type.$model"
                    :isError="$v.notificationForm.notification_type.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.notificationForm.notification_type.$invalid"
                    class="invalid-feedback-custom"
                  >Type should be filled.</div>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CInput label="Title" invalid-feedback="Title should be filled" required v-model="$v.notificationForm.title.$model" :is-valid="!$v.notificationForm.title.$invalid"/>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="8">
                <label for="nik">Message</label>
                <quill-editor style="height: 200px; margin-bottom:70px;"
                  :content="content"
                  :options="editorOption"
                  v-model="$v.notificationForm.messages.$model"
                  @change="onEditorChange($event)">
                </quill-editor>
                <div v-if="$v.notificationForm.messages.$invalid" class="invalid-feedback-custom">
                  Messages harus di isi.
                </div>
                <!-- <CTextarea required rows="4" label="Messages" invalid-feedback="Messages should be filled" v-model="$v.notificationForm.messages.$model" :is-valid="!$v.notificationForm.messages.$invalid"/> -->
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton color="danger" title="Edit" size="sm" class="text-center" @click="back">
              <i class="fa fa-undo"></i> Back
            </CButton>&nbsp;
            <CButton color="success" title="Detail" size="sm" @click="save">
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../templates/Loading";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "NotificationDetail",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "Notification Detail",
      userList: [],
      typeList: [],
      notificationForm: tableInterfaces.notification,
      items: [],
      isLoading: false,
      isEdit: false,
      addButton: false,
      activeTab: 0,
      content: '',editorOption: {},	// data quill
    };
  },
  validations: {
    notificationForm: {
      user_code : {required},
      title : {required},
      messages : {required},
      notification_type : {required},
      read : {},
      date_inserted : {},
      time_read : {},
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDropdown();
      this.getNotification(id);
    },
    back: function () {
      this.$router.go(-1);
    },
    getNotification: function (id) {
      this.isLoading = true;
      this.axios.get("console/notification/detail/" + id).then((response) => {
        if (response.data.status === 2000) {
          this.notificationForm = response.data.data;
          this.showInfoNotification({
            title: this.title,
            message: response.data.message,
          });
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message,
          });
        }
      }).catch((error) => {
        this.showErrorNotification({
          title: this.title,
          message: error,
        });
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getDropdown: function() {
      this.axios.get("/console/notification/dropdown").then(response => {
        this.userList = response.data.users;
        this.typeList = response.data.type;
      });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios.put("console/notification/update", this.notificationForm).then((response) => {
          this.showInfoNotification({
            title: "Ubah Notification",
            message: response.data.message,
          });
        }).catch((error) => {
          this.expired(error, "Ubah Notification");
        }).finally(() => {
          this.isLoading = false;
          let route = this.$route.path.split("/");
          this.init(route[4]);
        });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.notificationForm.message = html
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>